var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1393 7.935L33.0051 15.1992C32.9859 16.1958 33.6184 17.5183 34.4234 18.1125L39.1768 21.7158C42.2243 24.0158 41.7259 26.8333 38.0843 27.9833L31.8934 29.9192C30.8584 30.245 29.7659 31.3758 29.4976 32.43L28.0218 38.065C26.8526 42.5117 23.9393 42.9525 21.5243 39.0425L18.1509 33.58C17.5376 32.5833 16.0809 31.8358 14.9309 31.8933L8.52928 32.2192C3.94844 32.4492 2.64511 29.8042 5.63511 26.3158L9.43011 21.9075C10.1393 21.0833 10.4651 19.55 10.1393 18.515L8.18428 12.305C7.05345 8.66334 9.08511 6.65084 12.7076 7.83917L18.3618 9.69834C19.3201 10.005 20.7576 9.79417 21.5626 9.2L27.4659 4.945C30.6668 2.66417 33.2159 4.00584 33.1393 7.935Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0934 39.2341L35.2859 33.4266C34.7301 32.8708 33.8101 32.8708 33.2543 33.4266C32.6984 33.9825 32.6984 34.9025 33.2543 35.4583L39.0618 41.2658C39.3493 41.5533 39.7134 41.6875 40.0776 41.6875C40.4418 41.6875 40.8059 41.5533 41.0934 41.2658C41.6493 40.71 41.6493 39.79 41.0934 39.2341Z",
    fill: "#00CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/C2.1c779fdfffe975e027a64ac98f6e3400.svg";
export { ForwardRef as ReactComponent };